import { useQuery } from "@tanstack/react-query"
import axios from "axios"

export function useClientSubscriptionScheduleLookup(subscriptionId) {
    return useQuery({
        queryKey: ['client-subscription-schedule', subscriptionId],
        queryFn: async () => {
            if (!subscriptionId) return []

            return await axios({
                url: [
                    process.env.REACT_APP_API_URL,
                    '/client-schedule',
                    `?subscriptionId=${subscriptionId}`
                ].join(''),
                method: 'GET',
                withCredentials: true,
            }).then(response => {
                return response?.data?.data ?? []
            }).catch(error => {
                console.error('Schedule lookup error:', error)
                throw error?.response?.data ?? error
            })
        },
        enabled: !!subscriptionId,
        staleTime: 5 * 60 * 1000,
        retry: 2,
    })
}

export function useClientSubscriptions(clientId) {
    return useQuery({
        queryKey: ['client-subscriptions', clientId],
        queryFn: async () => {
            if (!clientId) return []

            return await axios({
                url: [
                    process.env.REACT_APP_API_URL,
                    '/subscriptions',
                    `?clientId=${clientId}`
                ].join(''),
                method: 'GET',
                withCredentials: true,
            }).then(response => {
                return response?.data?.data ?? []
            }).catch(error => {
                console.error('Subscription lookup error:', error)
                throw error?.response?.data ?? error
            })
        },
        enabled: !!clientId,
        staleTime: 5 * 60 * 1000,
        retry: 2,
    })
}
